export default __webpack_public_path__ + "static/media/24.5e1b7167.svg";